import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { FrontendConfiguration } from 'src/configuration/config.patientportal';
import { ErrorHandlingService } from './error-handling-service';

export interface IApplicationInsightsFactory {
    createApplicationInsightsInstance(router: Router): ApplicationInsights | null;
}

@Injectable({
    providedIn: 'root',
})
export class ApplicationInsightsFactory implements IApplicationInsightsFactory {
    private angularPlugin = new AngularPlugin();

    constructor(private toastController: ToastController) {}

    createApplicationInsightsInstance(router: Router): ApplicationInsights | null {
        const config = new FrontendConfiguration();
        if (
            config.appInsightsConnectionString !== null &&
            config.appInsightsConnectionString !== undefined &&
            config.appInsightsConnectionString !== '' &&
            config.appInsightsConnectionString !== '$appInsight'
        ) {
            const appInsights = new ApplicationInsights({
                config: {
                    connectionString: config.appInsightsConnectionString,
                    enableAutoRouteTracking: true,
                    extensions: [this.angularPlugin],
                    extensionConfig: {
                        [this.angularPlugin.identifier]: {
                            router: router,
                            // Application insights is registered as a main handler for errors, but it allows other error handlers to run. They are specified here.
                            errorServices: [new ErrorHandlingService(this.toastController)],
                        },
                        ['AppInsightsCfgSyncPlugin']: {
                            //In the new version of the library, the plugin loads the configuration file from the default Azure Monitor website,
                            // which causes a CSP error, the code below blocks the loading of the config.json file, which is unnecessary in our configuration
                            cfgUrl: '', // this will block fetching from default cdn
                        },
                    },
                },
            });
            return appInsights;
        } else {
            // Allow AppInsights integration to be optional. We might want to not enable logging to Insights on local environments or during automated tests.
            return null;
        }
    }
}
